module.exports = __webpack_public_path__ + "static/media/back6.ca6028c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back6.jpg
// module id = 1199
// module chunks = 0